<div class="gedcom-card">
    <div class="content">

        <div class="select-gedcom">
            <div class="title-container">
                <p i18n class="select-title">Select the GEDCOM file</p>
                <p i18n class="name-title">Name your file</p>
            </div>
            <div class="upload-box">
                <div class="file-upload">
                    <div class="file-select">
                        <label i18n class="file-select-button" id="fileName">Choose File</label>
                        <div class="file-select-name" id="noFile">{{fileInputName}}</div>
                        <input type="file" name="chooseFile" id="chooseFile"
                            (change)="handleFileInput($event.target.files)">
                    </div>
                </div>
                <input i18n type="text" class="file-name" [formControl]="userFilename">
                <button i18n class="upload-button" [disabled]="!userFilename.valid"
                    (click)="uploadFile()">Upload</button>
            </div>
            <div class="publicGEDCOM-container">
                <h2 i18n>Official GEDCOM-file</h2>
                <p i18n>Here you can add public GEDCOM files for testing or creation</p>
                <button i18n (click)="openStockSelector()">Select GEDCOM</button>
            </div>
            <p i18n class="note"><span>Note: </span>A GEDCOM file can take several hours to upload. Come back for
                status.
            </p>
            <div class="disclamer-text">
                <p i18n>We will not publish or in any way disclose your data or Gedcom files, without your
                    consent.Please
                    note
                    that the consent does not apply to whether we may process your data, but only to publication in our
                    web
                    system or website.</p>
                <a i18n href="https://ancytree.com/privacy-policy/" target="_blank">Read more about how we process your
                    data
                    in our Privacy Policy</a>
            </div>
        </div>
    </div>
</div>